import React, { Fragment, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { PropertyComplaintsCreators } from 'app/reducers/ReportPropertiesReducer'

import GeneralFeedback from 'components/Feedback'
import ReportPropertyForm from './FormReport'
import { Button, IonIcon, Modal, InputForm, TextAreaInputForm } from 'controls'

import { reportFormStyles } from './style'
import ReportSentMessage from './ReportSentMsg'

const ReportFormBtn = props => {
  const [isMsgOpen, setMsgOpen] = useState(false)

  const {
    property,
    openForm,
    initialValues,
    propertyReported,
    isPublicReport,
    onSubmitReport,
  } = props

  const {
    openReportModal,
    reportProperty,
    sendReportRequest,
    clearPostPropertyReport
  } = props.actions

  const postPropertyReport = useSelector(
    state => state.propertyReports.postPropertyReport
  )
  const reportValuesSelector = values => {
    const { reason, ...rest } = values

    return {
      ...rest,
      reason: reason.value
    }
  }

  const report = () => {
    openReportModal(true)
    reportProperty(property)
  }

  const submit = values => {
    const reportValues = reportValuesSelector(values)

    sendReportRequest(propertyReported.id, reportValues, isPublicReport)

    setMsgOpen(true)

    onSubmitReport()
  }

  const cancel = () => {
    openReportModal(false)
    clearPostPropertyReport()
  }

  const onClose = () => {
    openReportModal(false)
    clearPostPropertyReport()
  }

  const closeMsg = () => {
    setMsgOpen(false)
  }

  return (
    <Fragment>
      <Modal
        isOpen={
          propertyReported && propertyReported.id === property.id && openForm
        }
        onClose={() => onClose()}
      >
        <ReportPropertyForm
          loading={postPropertyReport.loading}
          onSubmit={submit}
          handleCancel={cancel}
          initialValues={initialValues}
          isPublicReport={isPublicReport}
        />
        <GeneralFeedback error={postPropertyReport.error} />
      </Modal>
      {postPropertyReport.success && (
        <ReportSentMessage openModal={isMsgOpen} handleFinish={closeMsg} />
      )}
      <Button
        outline
        onClick={() => report()}
        color="danger"
        style={{ marginRight: '0.5rem' }}
      >
        <IonIcon
          style={{ marginRight: '0.5rem' }}
          icon="ios-warning"
          className="back-icon"
        />
        Reportar
      </Button>
      <style jsx>{reportFormStyles}</style>
    </Fragment>
  )
}

ReportFormBtn.defaultProps = {
  onSubmitReport: () => {}
}

const mapStateToProps = state => ({
  propertyReported: state.propertyReports.propertyReported,
  openForm: state.propertyReports.isReportFormOpen
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      openReportModal: PropertyComplaintsCreators.openReportModal,
      reportProperty: PropertyComplaintsCreators.reportProperty,
      sendReportRequest: PropertyComplaintsCreators.sendReportRequest,
      clearPostPropertyReport:
        PropertyComplaintsCreators.clearPostPropertyReport
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportFormBtn)
